import { db } from './db';
import { nuevoUUID } from './uuid';
import type { Cita, Cliente } from '../types';

const META_KEY = 'migration_v1_done';
const LEGACY_KEY_CITAS = 'citas-clientes';
const LEGACY_KEY_CLIENTES = 'clientes-db';

interface ClienteLegacy {
  id: number;
  nombre: string;
  telefono: string;
  email?: string;
  notas?: string;
  creado?: string;
}

interface CitaLegacy {
  id: number;
  clienteId: number | null;
  cliente: string;
  telefono?: string;
  fecha: string;
  hora: string;
  notas?: string;
  notificacionesSilenciadas?: boolean;
  creada?: string;
}

let initPromise: Promise<void> | null = null;

export function inicializarDB(): Promise<void> {
  if (!initPromise) {
    initPromise = migrarDesdeLocalStorage();
  }
  return initPromise;
}

async function migrarDesdeLocalStorage(): Promise<void> {
  const marker = await db.meta.get(META_KEY);
  if (marker) return;

  const ahora = new Date().toISOString();
  const mapeoClientes = new Map<number, string>();

  const clientesRaw = leerLocal(LEGACY_KEY_CLIENTES);
  if (clientesRaw) {
    const viejos = JSON.parse(clientesRaw) as ClienteLegacy[];
    const nuevos: Cliente[] = viejos.map((c) => {
      const nuevoId = nuevoUUID();
      mapeoClientes.set(c.id, nuevoId);
      return {
        id: nuevoId,
        nombre: c.nombre,
        telefono: c.telefono,
        email: c.email ?? '',
        notas: c.notas ?? '',
        creado: c.creado ?? ahora,
        updatedAt: ahora,
        deletedAt: null,
      };
    });
    if (nuevos.length > 0) await db.clientes.bulkAdd(nuevos);
  }

  const citasRaw = leerLocal(LEGACY_KEY_CITAS);
  if (citasRaw) {
    const viejas = JSON.parse(citasRaw) as CitaLegacy[];
    const nuevas: Cita[] = viejas.map((c) => {
      const nuevoClienteId =
        c.clienteId !== null && c.clienteId !== undefined
          ? (mapeoClientes.get(c.clienteId) ?? null)
          : null;
      return {
        id: nuevoUUID(),
        clienteId: nuevoClienteId,
        cliente: c.cliente,
        telefono: c.telefono ?? '',
        fecha: c.fecha,
        hora: c.hora,
        notas: c.notas ?? '',
        notificacionesSilenciadas: c.notificacionesSilenciadas ?? false,
        creada: c.creada ?? ahora,
        updatedAt: ahora,
        deletedAt: null,
      };
    });
    if (nuevas.length > 0) await db.citas.bulkAdd(nuevas);
  }

  await db.meta.put({ key: META_KEY, value: true });
  console.log(
    `🗄️  Migración v1 completada: ${mapeoClientes.size} clientes, ${citasRaw ? JSON.parse(citasRaw).length : 0} citas`
  );
}

function leerLocal(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
